/** Shared comparison links and CTAs for blog posts (avoids circular imports with long-form content modules). */
export const commonLinks = {
  routeOpt: { label: 'Route optimization software', to: '/features/route-planner' },
  fleet: { label: 'Fleet management software', to: '/features/driver-app' },
  lastMile: { label: 'Last-mile delivery software', to: '/features/branded-tracking' },
  onfleet: { label: 'Geofleet vs Onfleet comparison', to: '/onfleet-alternative' },
  routific: { label: 'Geofleet vs Routific comparison', to: '/routific-alternative' },
  shipday: { label: 'Geofleet vs Shipday comparison', to: '/shipday-alternative' },
  circuit: { label: 'Geofleet vs Circuit comparison', to: '/circuit-alternative' },
  bringg: { label: 'Geofleet vs Bringg comparison', to: '/bringg-alternative' },
  locus: { label: 'Geofleet vs Locus comparison', to: '/locus-alternative' },
  lite: { label: 'Geofleet Lite: delivery software for one hub', to: '/lite' },
};

export const ctaAgents = {
  label: 'See how AI agents can optimize your operations',
  href: '/features/ai-agents',
  external: false as const,
};
export const ctaDemo = {
  label: 'Book a demo of Geofleet',
  href: 'https://meetings.hubspot.com/aditya145',
  external: true as const,
};
export const ctaTrial = {
  label: 'Get started with Geofleet',
  href: 'https://app.geofleet.ai/signup',
  external: true as const,
};
